<script setup lang="ts">
import { KollegeSakugenkahi } from '@/types/schema.generated'
import { computed } from 'vue'

const props = defineProps<{
  sakugenkahi?: KollegeSakugenkahi | null
}>()

const labelClassName = computed(() => {
  switch (props.sakugenkahi) {
    case KollegeSakugenkahi.Sakugenka:
      return 'label--sakugenka'
    case KollegeSakugenkahi.IchibuSakugenka:
      return 'label--ichibuSakugenka'
    case KollegeSakugenkahi.SakugenFuka:
      return 'label--sakugenFuka'
    default:
      return ''
  }
})

const labelText = computed(() => {
  switch (props.sakugenkahi) {
    case KollegeSakugenkahi.Sakugenka:
      return '削減可'
    case KollegeSakugenkahi.IchibuSakugenka:
      return '一部削減可'
    case KollegeSakugenkahi.SakugenFuka:
      return '削減不可'
    default:
      return '未入力'
  }
})
</script>

<template>
  <span :class="[$style.label, $style[labelClassName]]">{{ labelText }}</span>
</template>

<style lang="scss" module>
.label {
  font-size: 12px;
  line-height: 1.5;
  padding: 2px 12px;
  border-radius: 20px;
  border-style: solid;
  border-width: 1px;

  &--sakugenka {
    border-color: $color-success-border;
    background-color: $color-success-surface;
  }

  &--ichibuSakugenka {
    border-color: $color-warning-border;
    background-color: $color-warning-surface;
  }

  &--sakugenFuka {
    border-color: $color-caution-border;
    background-color: $color-caution-surface;
  }
}
</style>
